import { render, staticRenderFns } from "./CustomerSelect.vue?vue&type=template&id=657faeb1&"
import script from "./CustomerSelect.vue?vue&type=script&lang=js&"
export * from "./CustomerSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports